<template>
  <v-container>
    <v-layout justify-center row>
      <v-flex sm8 md6 lg5>
        <v-form @submit.prevent="onSubmit" novalidate class="elevation-2 pa-3">
          <Fields
            v-bind="{fields, object: formData, errors: formErrors}"
            />

          <v-btn type="submit" color="primary">Zapisz</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {updateRunner} from './api'
import Fields from '@/forms/Fields'
import formMixin from '@/utils/formMixin'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  components: {Fields},
  mixins: [formMixin],
  props: {
    runnerData: {
      type: Object
    }
  },
  data () {
    return {
      availableTrainers: []
    }
  },
  computed: {
    fields () {
      return [
        {comp: 'text', id: 'first_name', label: 'Imię:'},
        {comp: 'text', id: 'last_name', label: 'Nazwisko:'},
        {comp: 'text', id: 'individual_price', label: 'Cena indywidualna:'},
        {comp: 'select', id: 'package', label: 'Pakiet:', props: {items: this.allPackagesOptions}},
        {comp: 'select', id: 'trainer', label: 'Trener:', props: {items: this.availableTrainers}}
      ]
    },
    message () {
      return 'Konto zawodnika zostało edytowane.'
    },
    ...mapGetters(['allPackagesOptions', 'allTrainersOptions', 'getPackageById', 'getTrainerById'])
  },
  created () {
    this.formData = _.cloneDeep(this.runnerData)
    this.packageChange(this.formData.package)
    this.availableTrainers = this.allTrainersOptions
  },
  watch: {
    'formData.package': function (value, oldVal) {
      this.packageChange(value)
    }
  },
  methods: {
    packageChange (value) {
      let packageData = this.getPackageById(value)
      if (packageData && packageData.trainer) {
        let trainer = this.getTrainerById(packageData.trainer)
        if (trainer) {
          this.availableTrainers = [{value: trainer.id, text: trainer.full_name}]
          this.formData.trainer = trainer.id
        } else {
          this.availableTrainers = this.allTrainersOptions
        }
      } else {
        this.availableTrainers = this.allTrainersOptions
      }
    },
    submit (data) {
      return updateRunner(data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/runners/RunnerUpdateForm.vue